import { InjectionToken } from '@angular/core';

export interface HotkeysConfig {
  /** Scopes always active in addition to `setScopes()`. Default: `['global']`. */
  alwaysActiveScopes?: string[];
  /** Ignore hotkeys when focus is in these tag names (lowercase). */
  ignoreTags?: string[];
  /** Treat Meta as Ctrl on macOS when matching `ctrl+*` combos. */
  metaAsCtrlOnMac?: boolean;
}

export const HOTKEYS_CONFIG = new InjectionToken<HotkeysConfig>('HOTKEYS_CONFIG', {
  factory: () => ({
    alwaysActiveScopes: ['global'],
    ignoreTags: ['input', 'textarea', 'select'],
    metaAsCtrlOnMac: true,
  }),
});
